/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTile_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_itemSearch">;
    readonly " $refType": "ItemTile_itemSearch";
};
export type ItemTile_itemSearch$data = ItemTile_itemSearch;
export type ItemTile_itemSearch$key = {
    readonly " $data"?: ItemTile_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTile_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemTileBase_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'a939e50b2f2f197eaeeddbb58c1209f8';
export default node;
